const loadScript = async (src) => {
  if (document.querySelector(`script[src="${src}"]`)) {
    return;
  }
  const script = document.createElement('script');
  script.src = src;
  document.head.appendChild(script);
  await new Promise((resolve) => (script.onload = resolve));
};

export async function initSwCall() {
  try {
    await loadScript('https://contact.salework.net/api/callcenter/call-web-sdk.js');
  } catch (error) {
    console.error('initStringeeSDK -> error:', error);
  }
}